import React from "react";

export interface V3PerformanceSummaryTableProps {
  orderedFiltersForTable: string[];
  timeframePerformance: Record<string, number | null>;
  formatPerformance: (value: number) => string;
  isDarkMode?: boolean;
  // Captions the table as gross of fees (Discover detail page).
  showGrossOfFeesNote?: boolean;
  appearance?: "default" | "alpha";
}

/**
 * Per-period cumulative-return summary grid for the V3 factors chart. Extracted
 * from PerformanceChartV3Content so the detail-page "Net & Benchmark" view shows
 * the same gross figures. Figures are always gross; the optional note labels
 * them as such.
 */
const V3PerformanceSummaryTable: React.FC<V3PerformanceSummaryTableProps> = ({
  orderedFiltersForTable,
  timeframePerformance,
  formatPerformance,
  isDarkMode = true,
  showGrossOfFeesNote = false,
  appearance = "default",
}) => {
  const isAlpha = appearance === "alpha";
  return (
    <div className={`mt-4 border-t pt-4 ${isAlpha ? "border-v7-ink/15" : isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
        {orderedFiltersForTable.map(filter => {
          const perf = timeframePerformance[filter];
          return (
            <div key={filter} className="text-center">
              <p className={`mb-0.5 text-[10px] ${isAlpha ? "text-v7-ink/60" : "text-gray-500"}`}>{filter}</p>
              <p
                className={`text-sm font-bold ${
                  perf !== null && perf !== undefined
                    ? perf >= 0
                      ? isAlpha ? "text-v7-success" : isDarkMode ? "text-slate-200" : "text-gray-900"
                      : isAlpha ? "text-v7-rust" : "text-red-600"
                    : isAlpha ? "text-v7-ink/40" : "text-gray-500"
                }`}
              >
                {perf !== null && perf !== undefined ? formatPerformance(perf) : "-"}
              </p>
            </div>
          );
        })}
      </div>
      {showGrossOfFeesNote && (
        <p className={`mt-3 text-center text-[10px] ${isAlpha ? "text-v7-ink/60" : isDarkMode ? "text-gray-500" : "text-gray-400"}`}>
          Figures are gross of fees. The net-of-fees line (1% annual) is the amber line on the chart above.
        </p>
      )}
    </div>
  );
};

export default V3PerformanceSummaryTable;
